export default "__VITE_ASSET__BxxBGmhq__"